export default "__VITE_ASSET__XbQbZsNj__"